module.exports = __webpack_public_path__ + "e3f1dd8f7ae1fb02a1952eff2b4ec460.png";